// 読み込み完了したら、recommend-section-wrapperクラスにあるhiddenを削除する
document.addEventListener('DOMContentLoaded', event => {
  const recommendSectionWrapper = document.querySelector(".recommend-section-wrapper");
  recommendSectionWrapper.classList.remove("hidden");

  const swiper = new Swiper(".recommend-swiper", {
    grabCursor: true,
    loop: true,
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1280: {
        slidesPerView: 6,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      320: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
    }
  
  });
});
